/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespComponents_shippingFilters = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SbSharedPersonalizedFilterToast_shippingFilters">;
    readonly " $refType": "SbRespComponents_shippingFilters";
}>;
export type SbRespComponents_shippingFilters$data = SbRespComponents_shippingFilters;
export type SbRespComponents_shippingFilters$key = ReadonlyArray<{
    readonly " $data"?: SbRespComponents_shippingFilters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespComponents_shippingFilters">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespComponents_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPersonalizedFilterToast_shippingFilters",
      "args": null
    }
  ]
};
(node as any).hash = 'efe06964b9b07555da0ee972e23cecaa';
export default node;
